
import CryptoJS from "crypto-js";

export function generateGuid(template: { phone?: string; name?: string; email?: string }): string {
  const now = new Date();
  const timeFactor = `${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}${String(now.getHours()).padStart(2, '0')}${Math.ceil((now.getMinutes() * 100) / 1000)}`;

  const templateJson = JSON.stringify(template);

  const hashHex = CryptoJS.SHA256(templateJson).toString(CryptoJS.enc.Hex);

  const guid = `${hashHex}ft${timeFactor}`;
  return guid;
}

